<div class="page">
	<div
		class="page-content fw-bold justify-content-center align-items-center text-center"
	>
		<h1 class="text-primary h3 mb-3">{{ "HealthSurvey" | translate }}</h1>
		<p class="card-text" [innerHtml]="'CareXNoReport' | translate"></p>
	</div>
</div>
